import React from 'react';

const Products = () => {
  const products = [
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/11a9c4a189-fea77818eb42a68ae4fd.png',
      badge: 'Premium',
      badgeColor: 'bg-primary',
      title: 'Sapi Qurban',
      description: 'Sapi berkualitas tinggi dengan sertifikat kesehatan lengkap, dipelihara dengan pakan organik dan perawatan terbaik.',
      features: [
        'Sertifikat kesehatan lengkap',
        'Berat sesuai standar syariah',
        'Gratis pengiriman area Jabodetabek'
      ],
      buttonText: 'Lihat Detail'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/ed480bf35e-012fce776ae48a7e61bc.png',
      badge: 'Populer',
      badgeColor: 'bg-secondary',
      title: 'Domba & Kambing Qurban',
      description: 'Domba dan kambing pilihan dengan kualitas terjamin, dipelihara secara tradisional dengan standar modern.',
      features: [
        'Umur dan berat ideal',
        'Bebas penyakit dan cacat',
        'Layanan pemotongan profesional'
      ],
      buttonText: 'Lihat Detail'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/1ef26a5637-d836483c4bfb387bb739.png',
      badge: 'Custom',
      badgeColor: 'bg-accent',
      badgeTextColor: 'text-primary',
      title: 'Custom Order',
      description: 'Layanan pemesanan khusus sesuai kebutuhan spesifik Anda, dengan konsultasi lengkap dari tim ahli kami.',
      features: [
        'Konsultasi gratis',
        'Spesifikasi sesuai permintaan',
        'Garansi kualitas'
      ],
      buttonText: 'Konsultasi Sekarang'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/50a78a7a4f-edac6e8693e384c142b4.png',
      badge: 'Kemitraan',
      badgeColor: 'bg-secondary',
      title: 'Mitra Area',
      description: 'Portal khusus untuk mitra ternak dengan dashboard lengkap untuk mengelola investasi dan kemitraan ternak Anda.',
      features: [
        'Dashboard investasi real-time',
        'Laporan keuntungan bulanan',
        'Manajemen portfolio ternak'
      ],
      buttonText: 'Akses Mitra Area',
      isSpecial: true,
      link: '/mitra-area'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/333790fffd-078b602bd1e6313c2d58.png',
      badge: 'Organik',
      badgeColor: 'bg-primary',
      title: 'Organic Farming',
      description: 'Produk pertanian organik segar langsung dari kebun, ditanam tanpa pestisida dan pupuk kimia berbahaya.',
      features: [
        '100% organik bersertifikat',
        'Segar dan bergizi tinggi',
        'Ramah lingkungan'
      ],
      buttonText: 'Lihat Produk'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/357837598e-dae18fedfc0ef034c580.png',
      badge: 'Nutrisi',
      badgeColor: 'bg-secondary',
      title: 'Pakan Ternak',
      description: 'Pakan ternak berkualitas tinggi dengan formula khusus untuk mendukung pertumbuhan dan kesehatan optimal.',
      features: [
        'Formula nutrisi seimbang',
        'Meningkatkan produktivitas',
        'Harga kompetitif'
      ],
      buttonText: 'Pesan Sekarang'
    },
    {
      image: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/8e2003e60d-cd9d54ba66b17f7fa6b1.png',
      badge: 'Edukasi',
      badgeColor: 'bg-accent',
      badgeTextColor: 'text-primary',
      title: 'Konsultasi & Pelatihan',
      description: 'Layanan konsultasi dan pelatihan untuk meningkatkan pengetahuan dan keterampilan dalam bidang peternakan.',
      features: [
        'Tim ahli berpengalaman',
        'Program pelatihan praktis',
        'Sertifikat resmi'
      ],
      buttonText: 'Daftar Pelatihan'
    }
  ];

  return (
    <section id="produk" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-light-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-accent/20 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-box mr-2"></i>
            Produk & Layanan
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Solusi Lengkap untuk<br className="hidden sm:block"/>
            <span className="text-secondary">Kebutuhan Anda</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            Dari hewan qurban berkualitas hingga produk organic farming, 
            kami menyediakan berbagai solusi untuk memenuhi kebutuhan Anda.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 sm:p-7 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 group">
              <div className="relative mb-5 sm:mb-6">
                <img className="w-full h-44 sm:h-48 object-cover rounded-xl" src={product.image} alt={product.title} />
                <div className={`absolute top-4 right-4 ${product.badgeColor} ${product.badgeTextColor || 'text-white'} px-3 py-1 rounded-full text-sm font-medium`}>
                  {product.badge}
                </div>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-3 group-hover:text-secondary transition-colors">
                {product.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed">
                {product.description}
              </p>
              <div className="space-y-3 mb-5 sm:mb-6">
                {product.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-sm text-gray-600">
                    <i className="fa-solid fa-check text-accent mr-2 flex-shrink-0"></i>
                    {feature}
                  </div>
                ))}
              </div>
              <button 
                className="w-full bg-accent text-primary py-3 rounded-xl font-semibold text-sm sm:text-base hover:bg-yellow-400 transition-colors"
                onClick={() => {
                  if (product.isSpecial && product.link) {
                    window.location.href = product.link;
                  }
                }}
              >
                {product.buttonText}
              </button>
            </div>
          ))}
        </div>

        <div className="bg-primary rounded-3xl p-8 sm:p-10 lg:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">
            Butuh Konsultasi Khusus?
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 max-w-2xl mx-auto px-2">
            Tim ahli kami siap membantu Anda menemukan solusi terbaik 
            sesuai kebutuhan spesifik Anda.
          </p>
          <button className="bg-accent text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-yellow-400 transition-colors">
            <i className="fa-solid fa-phone mr-2"></i>
            Hubungi Konsultan Kami
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;

